import Cookies from 'js-cookie';
import { apiAction, logEntry } from '../utils/index';

import {
  GET_ALL_MODEL_VARIANT_DETAILS,
  MODEL_VARIANT_IS_LOADING,
  UPDATE_MODEL_VARIANT_USER_SAVE_STATUS,
  MODEL_VARIANT_MANAGEMENT_ERROR,
  SET_MODEL_VARIANT_CURRENT_PAGE,
  SET_MODEL_VARIANT_PAGE_FILTER,
  SET_MODEL_VARIANT_DETAILS,
  SET_MODEL_VARIANT_DETAILS_DUPLICATE,
  SET_MODEL_VARIANT_CHANGE,
  MODEL_VARIANT_THRESHOLDS_MANAGEMENT_ERROR,
  GET_ALL_MODEL_VARIANT_DETAILS_THRESHOLDS,
   MODEL_VARIANT_THRESHOLDS_IS_LOADING,
  MODEL_VARIANT_SETPOINTS_MANAGEMENT_ERROR,
  MODEL_VARIANT_SETPOINTS_IS_LOADING,
  GET_ALL_MODEL_VARIANT_SETPOINTS,
  SET_MODEL_VARIANT_THRESHOLDS_DETAILS,
  SET_MODEL_VARIANT_THRESHOLDS_CHANGE,
  UPDATE_MODEL_VARIANT_THRESHOLDS_SHOW_SCREEN,
  UPDATE_MODEL_VARIANT_THRESHOLDS_SAVE_STATUS,
  UPDATE_MODEL_VARIANT_SETPOINTS_SAVE_STATUS,
  SET_MODEL_VARIANT_SETPOINTS_DETAILS,
  SET_MODEL_VARIANT_SETPOINTS_CHANGE,
  UPDATE_MODEL_VARIANT_SETPOINTS_SHOW_SCREEN,
  MODEL_VARIANT_UNITS_MANAGEMENT_ERROR,
  MODEL_VARIANT_UNITS_IS_LOADING,
  SET_MODEL_VARIANT_UNITS_CLEANUP,
  SET_MODEL_VARIANT_UNITS_CURRENT_PAGE,
  SET_MODEL_VARIANT_UNITS_FILTERED_RESULTS,
  UPDATE_MODEL_VARIANT_UNITS_SAVE_STATUS,
  GET_ALL_MODEL_VARIANT_UNITS,
  SET_MODEL_VARIANT_UNITS_CHANGE,
  UPDATE_MODEL_VARIANT_UNITS_SHOW_SCREEN,
  MODEL_VARIANT_MODEL_COMPONENTS_POSITIONS_MODEL,
  MODEL_VARIANT_UNIT_SETPOINTS_MANAGEMENT_ERROR,
  MODEL_VARIANT_UNIT_SETPOINTS_IS_LOADING,
  GET_ALL_MODEL_VARIANT_UNIT_SETPOINTS,
  SET_MODEL_VARIANT_UNIT_SETPOINTS_DETAILS,
  SET_MODEL_VARIANT_UNIT_SETPOINTS_CHANGE,
  UPDATE_MODEL_VARIANT_UNIT_SETPOINTS_SAVE_STATUS,
  UPDATE_MODEL_VARIANT_UNIT_SETPOINTS_SHOW_SCREEN,
  SET_MODEL_VARIANT_FILTERED_RESULTS,
} from '../constants/index';

import {
  MODEL_MANAGEMENT,
  UPDATE_MODEL_VARIANT,
  CREATE_MODEL_VARIANT,
  CREATE_MODEL_VARIANT_THRESHOLD,
  UPDATE_MODEL_VARIANT_THRESHOLD,
  CREATE_MODEL_VARIANT_SETPOINT,
  UPDATE_MODEL_VARIANT_SETPOINT,
  DELETE_MODEL_VARIANT_THRESHOLD,
  DELETE_MODEL_VARIANT_SETPOINT,
  UPDATE_MODEL_VARIANT_UNITS,
  MODELVARIANTSETPOINTS_MANAGEMENT,
  CREATE_MODELVARIANTSETPOINTS,
  UPDATE_MODELVARIANTSETPOINTS,
  DELETE_MODELVARIANTSETPOINTS,
  MODEL_VARIANT_SHADOW_UPDATE
} from '../constants/logs';


const envName = process.env.REACT_APP_ENV_NAME_SHORT;

//Model Variant Management
export const setModelVariantErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  dispatch(setModelVariantError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setModelVariantError(messageCode, false));
  }, 2500);
};

export const setModelVariantError = (messageCode, status) => {
  return {
    type: MODEL_VARIANT_MANAGEMENT_ERROR,
    payload: {
      data: {
        isOpSuccessful: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const getModelVariantsThunk = (modelId, offset, limit, filter, widgetCode, organisationId, modelCategoryId) => dispatch => {
  dispatch(getModelVariant(modelId, offset, limit, filter, widgetCode, organisationId, modelCategoryId));
};

export const setLoadingStatus = isLoading => ({
  type: MODEL_VARIANT_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const getModelVariant = (modelId, offset, limit, filter, widgetCode, organisationId, modelCategoryId) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/modelvariant`,
    data: {
      ModelId: modelId,
      Offset: offset,
      Limit: limit,
      Filter: filter,
      OrganisationId: organisationId ? organisationId : null,
      ModelCategoryId: modelCategoryId || null
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setAllModelVariantListThunk(retData),
    onFailure: err => setModelVariantErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setAllModelVariantListThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let modelVariants = (retData && retData.modelVariants) || [];
  dispatch(setAllModelVariantList(messageCode, modelVariants));
};

export const setAllModelVariantList = (messageCode, modelVariants) => ({
  type: GET_ALL_MODEL_VARIANT_DETAILS,
  payload: {
    data: {
      modelVariants: modelVariants,
      filteredResults: modelVariants,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false,
      isOpSuccessful: false
    }
  }
});

export const setCurrentPage = currentPage => ({
  type: SET_MODEL_VARIANT_CURRENT_PAGE,
  payload: { currentPage }
});

export const setPageFilter = filter => ({
  type: SET_MODEL_VARIANT_PAGE_FILTER,
  payload: { filter }
});

export const setFilteredDataThunk = retData => dispatch => {
  dispatch(setFilteredData(retData));
};

export const setFilteredData = retData => ({
  type: SET_MODEL_VARIANT_FILTERED_RESULTS,
  payload: retData
});

export const postModelVariantThunk = (modelvariant, widgetCode) => dispatch => {
  let url = '/management/modelvariant/save';
  let actionName = modelvariant.ModelVariantId === 0 ? CREATE_MODEL_VARIANT : UPDATE_MODEL_VARIANT;
  let log = logEntry(MODEL_MANAGEMENT, actionName, modelvariant);
  dispatch(saveModelVariant(modelvariant, url, log, widgetCode));
};

export const saveModelVariant = (modelvariant, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    onLoad: status => setLoadingStatus(status),
    onSuccess: message => setModelVariantStatusThunk(message),
    onFailure: err => setModelVariantErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      ModelVariant: modelvariant,
      log: log
    },
    widgetcode: widgetCode
  });

export const setModelVariantStatusThunk = message => dispatch => {
  dispatch(setModelVariantStatus(message, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setModelVariantStatus('', false));
  }, 2500);
};

export const setModelVariantStatus = (messageCode, status) => ({
  type: UPDATE_MODEL_VARIANT_USER_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessful: true,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const describeModelVariantThunk = (modelVariantId, isDuplicate, widgetCode, modelCategoryId) => dispatch => {
  dispatch(describeModelVariant(modelVariantId, isDuplicate, widgetCode, modelCategoryId));
};

export const describeModelVariant = (modelVariantId, isDuplicate, widgetCode, modelCategoryId) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/modelvariant/describe`,
    data: {
      ModelVariantId: modelVariantId || undefined,
      includeOrganisation: isDuplicate ? true : false,
      OrganisationId: Cookies.get(`selectedorganisationid-${envName}`) || 0,
      ModelCategoryId: modelCategoryId || undefined
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => (isDuplicate ? setdescribeModelVariantDuplicateThunk(retData) : setdescribeModelVariantThunk(retData)),
    onFailure: err => setModelVariantErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setdescribeModelVariantThunk = retData => dispatch => {
  dispatch(setDescribeModelVariant(retData));
};

export const setDescribeModelVariant = ({ retData }) => ({
  type: SET_MODEL_VARIANT_DETAILS,
  payload: retData
});

export const setdescribeModelVariantDuplicateThunk = retData => dispatch => {
  dispatch(setDescribeModelVariantDuplicate(retData));
};

export const setDescribeModelVariantDuplicate = ({ retData }) => ({
  type: SET_MODEL_VARIANT_DETAILS_DUPLICATE,
  payload: retData
});

export const setModelVariantChangeThunk = retData => dispatch => {
  dispatch(setModelVariantChange(retData));
};

export const setModelVariantChange = retData => ({
  type: SET_MODEL_VARIANT_CHANGE,
  payload: retData
});

// Thresholds

export const setThresholdsErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  dispatch(setThresholdError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setThresholdError(messageCode, false));
  }, 2500);
};

export const setThresholdError = (messageCode, status) => {
  return {
    type: MODEL_VARIANT_THRESHOLDS_MANAGEMENT_ERROR,
    payload: {
      data: {
        isOpSuccessful: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const getThresholdsThunk = (offset, limit, filter, modelVariantId, widgetCode) => dispatch => {
  if (modelVariantId) {
    dispatch(getThesholds(offset, limit, filter, modelVariantId, widgetCode));
  }
};

export const setThresholdLoadingStatus = isLoading => ({
  type: MODEL_VARIANT_THRESHOLDS_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const setThresholdShowScreenStatusThunk = status => dispatch => {
  dispatch(setThresholdShowScreenStatus(status));
};

export const setThresholdShowScreenStatus = status => ({
  type: UPDATE_MODEL_VARIANT_THRESHOLDS_SHOW_SCREEN,
  payload: { showAddEditScreen: status }
});

export const getThesholds = (offset, limit, filter, modelVariantId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/modelvariant/threshold`,
    data: {
      Offset: offset,
      Limit: limit,
      Filter: filter,
      ModelVariantId: modelVariantId
    },
    method: 'GET',
    onLoad: status => setThresholdLoadingStatus(status),
    onSuccess: retData => setAllThesholdListThunk(retData),
    onFailure: err => setThresholdsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setAllThesholdListThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let modelVariantsThresholds = (retData && retData.modelVariantsThresholds) || [];
  dispatch(setAllThresholdList(messageCode, modelVariantsThresholds));
};

export const setAllThresholdList = (messageCode, modelVariantsThresholds) => ({
  type: GET_ALL_MODEL_VARIANT_DETAILS_THRESHOLDS,
  payload: {
    data: {
      ThresholdsList: modelVariantsThresholds,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false
    }
  }
});

export const describeThresholdThunk = (modelVariantsThresholdId, widgetCode) => dispatch => {
  dispatch(describeThreshold(modelVariantsThresholdId, widgetCode));
};

export const describeThreshold = (modelVariantsThresholdId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/modelvariant/threshold/describe`,
    data: {
      ModelVariantThresholdId: modelVariantsThresholdId || undefined
    },
    method: 'GET',
    onLoad: status => setThresholdLoadingStatus(status),
    onSuccess: retData => setdescribeThresholdThunk(retData),
    onFailure: err => setThresholdsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setdescribeThresholdThunk = retData => dispatch => {
  dispatch(setDescribeThreshold(retData));
};

export const setDescribeThreshold = ({ retData }) => ({
  type: SET_MODEL_VARIANT_THRESHOLDS_DETAILS,
  payload: retData
});

export const setThresholdChangeThunk = retData => dispatch => {
  dispatch(setThresholdChange(retData));
};

export const setThresholdChange = retData => ({
  type: SET_MODEL_VARIANT_THRESHOLDS_CHANGE,
  payload: retData
});

export const postThresholdThunk = (modelvariantThreshold, widgetCode) => dispatch => {
  let url = '/management/modelvariant/threshold/save';
  let actionName = modelvariantThreshold.PerformDelete
    ? DELETE_MODEL_VARIANT_THRESHOLD
    : modelvariantThreshold.ModelVariantThresholdId === 0
    ? CREATE_MODEL_VARIANT_THRESHOLD
    : UPDATE_MODEL_VARIANT_THRESHOLD;

  let log = logEntry(MODEL_MANAGEMENT, actionName, modelvariantThreshold);
  dispatch(saveThreshold(modelvariantThreshold, url, log, widgetCode));
};

export const saveThreshold = (modelvariantThreshold, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    onLoad: status => setThresholdLoadingStatus(status),
    onSuccess: retData => setThresholdStatusThunk(retData),
    onFailure: err => setThresholdsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      Threshold: modelvariantThreshold,
      log: log
    },
    widgetcode: widgetCode
  });

export const setThresholdStatusThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let modelVariantsThresholds = (retData && retData.modelVariantsThresholds) || [];

  dispatch(setThresholdStatusAndData(messageCode, modelVariantsThresholds, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setThresholdStatus('hhhh', false));
  }, 2500);
};

export const setThresholdStatusAndData = (messageCode, data, status) => ({
  type: UPDATE_MODEL_VARIANT_THRESHOLDS_SAVE_STATUS,
  payload: {
    data: {
      ThresholdsList: data,
      isOpSuccessful: true,
      showBanner: status,
      isLoading: false,
      showAddEditScreen: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setThresholdStatus = (messageCode, status) => ({
  type: UPDATE_MODEL_VARIANT_THRESHOLDS_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessful: true,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});

//Setpoints

export const setGlobalSetingsErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  dispatch(setGlobalSetingsError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setGlobalSetingsError(messageCode, false));
  }, 2500);
};

export const setGlobalSetingsError = (messageCode, status) => {
  return {
    type: MODEL_VARIANT_SETPOINTS_MANAGEMENT_ERROR,
    payload: {
      data: {
        isOpSuccessfull: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const getGlobalSetingsThunk = (offset, limit, filter, modelVariantId, widgetCode) => dispatch => {
  if (modelVariantId) {
    dispatch(getGlobalSetings(offset, limit, filter, modelVariantId, widgetCode));
  }
};

export const setGlobalSetingsLoadingStatus = isLoading => ({
  type: MODEL_VARIANT_SETPOINTS_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const getGlobalSetings = (offset, limit, filter, modelVariantId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/modelvariant/setpoints`,
    data: {
      Offset: offset,
      Limit: limit,
      Filter: filter,
      ModelVariantId: modelVariantId
    },
    method: 'GET',
    onLoad: status => setGlobalSetingsLoadingStatus(status),
    onSuccess: retData => setAllGlobalSetingsListThunk(retData),
    onFailure: err => setGlobalSetingsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setAllGlobalSetingsListThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let modelSetpoints = (retData && retData.modelSetpoints) || [];
  dispatch(setAllGlobalSetingsList(messageCode, modelSetpoints));
};

export const setAllGlobalSetingsList = (messageCode, modelSetpoints) => ({
  type: GET_ALL_MODEL_VARIANT_SETPOINTS,
  payload: {
    data: {
      SetpointsList: modelSetpoints,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false
    }
  }
});

export const describeGlobalSetingThunk = (modelSetpointId, widgetCode) => dispatch => {
  dispatch(describeGlobalSeting(modelSetpointId, widgetCode));
};

export const describeGlobalSeting = (modelSetpointId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/modelvariant/setpoints/describe`,
    data: {
      ModelSetpointId: modelSetpointId || undefined
    },
    method: 'GET',
    onLoad: status => setGlobalSetingsLoadingStatus(status),
    onSuccess: retData => setdescribeGlobalSetingThunk(retData),
    onFailure: err => setGlobalSetingsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setdescribeGlobalSetingThunk = retData => dispatch => {
  dispatch(setDescribeGlobalSeting(retData));
};

export const setDescribeGlobalSeting = ({ retData }) => ({
  type: SET_MODEL_VARIANT_SETPOINTS_DETAILS,
  payload: retData
});

export const setGlobalSetingChangeThunk = retData => dispatch => {
  dispatch(setGlobalSetingChange(retData));
};

export const setGlobalSetingChange = retData => ({
  type: SET_MODEL_VARIANT_SETPOINTS_CHANGE,
  payload: retData
});

export const postGlobalSetingThunk = (modelSetpoint, widgetCode) => dispatch => {
  let url = '/management/modelvariant/setpoints/save';
  let actionName = modelSetpoint.PerformDelete
    ? DELETE_MODEL_VARIANT_SETPOINT
    : modelSetpoint.ModelSetpointId === 0
    ? CREATE_MODEL_VARIANT_SETPOINT
    : UPDATE_MODEL_VARIANT_SETPOINT;
  let log = logEntry(MODEL_MANAGEMENT, actionName, modelSetpoint);
  dispatch(saveGlobalSeting(modelSetpoint, url, log, widgetCode));
};

export const saveGlobalSeting = (modelSetpoint, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    onLoad: status => setGlobalSetingsLoadingStatus(status),
    onSuccess: retData => setGlobalSetingStatusThunk(retData),
    onFailure: err => setGlobalSetingsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      Setpoint: modelSetpoint,
      log: log
    },
    widgetcode: widgetCode
  });

export const setGlobalSetingStatusThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let modelSetpoints = (retData && retData.modelSetpoints) || [];

  dispatch(setGlobalSetingStatusAndData(messageCode, modelSetpoints, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setGlobalSetingStatus('hhhh', false));
  }, 2500);
};

export const setGlobalSetingStatusAndData = (messageCode, data, status) => ({
  type: UPDATE_MODEL_VARIANT_SETPOINTS_SAVE_STATUS,
  payload: {
    data: {
      SetpointsList: data,
      isOpSuccessfull: true,
      showBanner: status,
      isLoading: false,
      showAddEditScreen: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setGlobalSetingStatus = (messageCode, status) => ({
  type: UPDATE_MODEL_VARIANT_SETPOINTS_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessfull: true,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setGlobalSetingShowScreenStatusThunk = status => dispatch => {
  dispatch(setGlobalSetingShowScreenStatus(status));
};

export const setGlobalSetingShowScreenStatus = status => ({
  type: UPDATE_MODEL_VARIANT_SETPOINTS_SHOW_SCREEN,
  payload: { showAddEditScreen: status }
});

// Model variant Units

export const setModelVariantUnitsErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  dispatch(setModelVariantUnitsError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setModelVariantUnitsError(messageCode, false));
  }, 2500);
};

export const setModelVariantUnitsError = (messageCode, status) => {
  return {
    type: MODEL_VARIANT_UNITS_MANAGEMENT_ERROR,
    payload: {
      data: {
        isOpSuccessfull: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const setModelVariantUnitsLoadingStatus = isLoading => ({
  type: MODEL_VARIANT_UNITS_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const setModelVariantUnitsStatusThunk = UnitData => dispatch => {
  let messageCode = UnitData && UnitData.message;
  let data = (UnitData && UnitData.retData) || [];

  dispatch(setModelVariantUnitsStatusAndData(messageCode, data, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setModelVariantUnitsError('', false));
  }, 2500);
};

export const setModelVariantUnitsStatusAndData = (messageCode, data, status) => ({
  type: UPDATE_MODEL_VARIANT_UNITS_SAVE_STATUS,
  payload: {
    data: {
      ModelVariantUnitsList: data.AllocatedUnits,
      UnallocatedUnitsList: data.UnallocatedUnits,
      isOpSuccessfull: true,
      showBanner: status,
      isLoading: false,
      showAddEditScreen: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setAllModelVariantUnitsListThunk = UnitData => dispatch => {
  let messageCode = UnitData && UnitData.message;
  let data = (UnitData && UnitData.UnitData) || [];
  dispatch(setAllModelVariantUnitsList(messageCode, data));
};

export const setAllModelVariantUnitsList = (messageCode, data) => ({
  type: GET_ALL_MODEL_VARIANT_UNITS,
  payload: {
    data: {
      ModelVariantUnitsList: data.AllocatedUnits,
      filteredResults: data.AllocatedUnits,
      UnallocatedUnitsList: data.UnallocatedUnits,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false
    }
  }
});

export const setModelVariantUnitsChangeThunk = UnitData => dispatch => {
  dispatch(setModelVariantUnitsChange(UnitData));
};

export const setModelVariantUnitsChange = UnitData => ({
  type: SET_MODEL_VARIANT_UNITS_CHANGE,
  payload: UnitData
});

export const setModelVariantUnitsScreenStatusThunk = status => dispatch => {
  dispatch(setModelVariantUnitsScreenStatus(status));
};

export const setModelVariantUnitsScreenStatus = status => ({
  type: UPDATE_MODEL_VARIANT_UNITS_SHOW_SCREEN,
  payload: { showAddEditScreen: status }
});

export const getModelVariantUnitsThunk = (item, widgetCode) => dispatch => {
  if (item.ModelVariantId) {
    dispatch(getModelVariantUnits(item, widgetCode));
  }
};

export const getModelVariantUnits = (item, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/modelvariant/units`,
    data: {
      Offset: item.offset,
      Limit: item.limit,
      Filter: item.filter,
      ModelVariantId: item.ModelVariantId,
      ModelId: item.ModelId,
      OrganisationId: Cookies.get(`selectedorganisationid-${envName}`) || 0,
      ProfileId: Cookies.get(`selectedprofileid-${envName}`) || 0,
      UserId: Cookies.get(`userid-${envName}`) || 0
    },
    method: 'GET',
    onLoad: status => setModelVariantUnitsLoadingStatus(status),
    onSuccess: retData => setAllModelVariantUnitsListThunk(retData),
    onFailure: err => setModelVariantUnitsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const saveModelVariantUnitsThunk = (modelVariantUnits, widgetCode) => dispatch => {
  let url = '/management/modelvariant/units/save';
  let actionName = UPDATE_MODEL_VARIANT_UNITS;
  let log = logEntry(MODEL_MANAGEMENT, actionName, modelVariantUnits);

  modelVariantUnits.OrganisationId = Cookies.get(`selectedorganisationid-${envName}`);
  modelVariantUnits.ProfileId = Cookies.get(`selectedprofileid-${envName}`);
  modelVariantUnits.UserId = Cookies.get(`userid-${envName}`);

  dispatch(saveModelVariantUnits(modelVariantUnits, url, log, widgetCode));
};

export const saveModelVariantUnits = (modelVariantUnits, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    onLoad: status => setModelVariantUnitsLoadingStatus(status),
    onSuccess: retData => setModelVariantUnitsStatusThunk(retData),
    onFailure: err => setModelVariantUnitsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      ModelVariant: modelVariantUnits,
      log: log
    },
    widgetcode: widgetCode
  });

  export const setModelVariantUnitsFilteredDataThunk = retData => dispatch => {
    dispatch(setModelVariantUnitsFilteredData(retData));
  };

  export const setModelVariantUnitsFilteredData = retData => ({
    type: SET_MODEL_VARIANT_UNITS_FILTERED_RESULTS,
    payload: retData
  });
  
  export const setModelVariantUnitsCurrentPage = currentPage => ({
    type: SET_MODEL_VARIANT_UNITS_CURRENT_PAGE,
    payload: { currentPage }
  });

  export const resetModelVariantUnitsThunk = retData => dispatch => {
    dispatch(resetModelVariantUnits(retData));
  };

  export const resetModelVariantUnits = retData => ({
    type: SET_MODEL_VARIANT_UNITS_CLEANUP,
    payload: retData
  });

//Get Model Component Position by ModelId

export const getModelComponentPositionsThunk = (modelId, onlyVirtual, telemetryComponent, widgetCode) => dispatch => {
  if (modelId) {
    dispatch(getModelComponentPositions(modelId, onlyVirtual, telemetryComponent, widgetCode));
  }
};

export const getModelComponentPositions = (modelId, onlyVirtual, telemetryComponent, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/model/componentposition`,
    data: {
      ModelId: modelId,
      OnlyVirtual: onlyVirtual,
      Telemetry: telemetryComponent
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setAllModelComponentPositionsListThunk(retData),
    onFailure: err => setModelVariantErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setAllModelComponentPositionsListThunk = ({ retData }) => dispatch => {
  let componentPositionDetails = (retData && retData.componentPositionDetails) || [];
  dispatch(setAllModelComponentPositionsList(componentPositionDetails));
};

export const setAllModelComponentPositionsList = componentPositionDetails => ({
  type: MODEL_VARIANT_MODEL_COMPONENTS_POSITIONS_MODEL,
  payload: {
    data: {
      ModelComponentPositions: componentPositionDetails
    }
  }
});


//Unit setpoints
//====================
export const setModelVariantSetpointsErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  dispatch(setModelVariantSetpointsError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setModelVariantSetpointsError(messageCode, false));
  }, 2500);
};

export const setModelVariantSetpointsError = (messageCode, status) => {
  return {
    type: MODEL_VARIANT_UNIT_SETPOINTS_MANAGEMENT_ERROR,
    payload: {
      data: {
        isOpSuccessfull: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const getModelVariantSetpointsThunk = (offset, limit, filter, modelVariantId, widgetCode) => dispatch => {
  if (modelVariantId) {
    dispatch(getModelVariantSetpoints(offset, limit, filter, modelVariantId, widgetCode));
  }
};

export const setModelVariantSetpointsLoadingStatus = isLoading => ({
  type: MODEL_VARIANT_UNIT_SETPOINTS_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const getModelVariantSetpoints = (offset, limit, filter, modelVariantId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/modelvariant/modelvariantsetpoints`,
    data: {
      Offset: offset,
      Limit: limit,
      Filter: filter,
      ModelVariantId: modelVariantId
    },
    method: 'GET',
    onLoad: status => setModelVariantSetpointsLoadingStatus(status),
    onSuccess: retData => setAllModelVariantSetpointsListThunk(retData),
    onFailure: err => setModelVariantSetpointsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setAllModelVariantSetpointsListThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let modelVariantSetpoints = (retData && retData.modelVariantSetpoints) || [];
  dispatch(setAllModelVariantSetpointsList(messageCode, modelVariantSetpoints));
};

export const setAllModelVariantSetpointsList = (messageCode, modelVariantSetpoints) => ({
  type: GET_ALL_MODEL_VARIANT_UNIT_SETPOINTS,
  payload: {
    data: {
      ModelVariantSetpointsList: modelVariantSetpoints,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false
    }
  }
});

export const describeModelVariantSetpointThunk = (modelVariantSetpointId, widgetCode) => dispatch => {
  dispatch(describeModelVariantSetpoint(modelVariantSetpointId, widgetCode));
};

export const describeModelVariantSetpoint = (modelVariantSetpointId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/modelvariant/modelvariantsetpoints`,
    data: {
      ModelVariantSetpointId: modelVariantSetpointId || undefined
    },
    method: 'GET',
    onLoad: status => setModelVariantSetpointsLoadingStatus(status),
    onSuccess: retData => setdescribeModelVariantSetpointThunk(retData),
    onFailure: err => setModelVariantSetpointsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setdescribeModelVariantSetpointThunk = retData => dispatch => {
  dispatch(setDescribeModelVariantSetpoint(retData));
};

export const setDescribeModelVariantSetpoint = retData => ({
  type: SET_MODEL_VARIANT_UNIT_SETPOINTS_DETAILS,
  payload: retData
});

export const setModelVariantSetpointChangeThunk = retData => dispatch => {
  dispatch(setModelVariantSetpointChange(retData));
};

export const setModelVariantSetpointChange = retData => ({
  type: SET_MODEL_VARIANT_UNIT_SETPOINTS_CHANGE,
  payload: retData
});

export const postModelVariantSetpointThunk = (modelVariantSetpoint, widgetCode) => dispatch => {
  let url = '/management/modelvariant/modelvariantsetpoints/save';
  let actionName = modelVariantSetpoint.MarkAsDeleted
    ? DELETE_MODELVARIANTSETPOINTS
    : modelVariantSetpoint.ModelVariantSetpointId === 0
    ? CREATE_MODELVARIANTSETPOINTS
    : UPDATE_MODELVARIANTSETPOINTS;
  let log = logEntry(MODELVARIANTSETPOINTS_MANAGEMENT, actionName, modelVariantSetpoint);
  dispatch(saveModelVariantSetpoint(modelVariantSetpoint, url, log, widgetCode));
};

export const saveModelVariantSetpoint = (modelVariantSetpoint, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    onLoad: status => setModelVariantSetpointsLoadingStatus(status),
    onSuccess: retData => setModelVariantSetpointStatusThunk(retData),
    onFailure: err => setModelVariantSetpointsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      modelVariantSetpoint: { ...modelVariantSetpoint },
      log: log
    },
    widgetcode: widgetCode
  });

export const setModelVariantSetpointStatusThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let modelVariantSetpoints = (retData && retData.modelVariantSetpoints) || [];

  dispatch(setModelVariantSetpointStatusAndData(messageCode, modelVariantSetpoints, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setModelVariantSetpointStatus('', false));
  }, 2500);
};

export const setModelVariantSetpointStatusAndData = (messageCode, data, status) => ({
  type: UPDATE_MODEL_VARIANT_UNIT_SETPOINTS_SAVE_STATUS,
  payload: {
    data: {
      ModelVariantSetpointsList: data,
      isOpSuccessfull: true,
      showBanner: status,
      isLoading: false,
      showAddEditScreen: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setModelVariantSetpointStatus = (messageCode, status) => ({
  type: UPDATE_MODEL_VARIANT_UNIT_SETPOINTS_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessfull: true,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setModelVariantSetpointShowScreenStatusThunk = status => dispatch => {
  dispatch(setModelVariantSetpointShowScreenStatus(status));
};

export const setModelVariantSetpointShowScreenStatus = status => ({
  type: UPDATE_MODEL_VARIANT_UNIT_SETPOINTS_SHOW_SCREEN,
  payload: { showAddEditScreen: status }
});


//Shadow update
export const uploadConfigToS3AndUpdateShadowThunk = (modelCategoryId, modelId, modelVariantId, widgetCode) => dispatch => {
  let url = `/management/modelvariant/updateunitshadow`;
  let actionName = MODEL_VARIANT_SHADOW_UPDATE;
  let log = logEntry(MODEL_VARIANT_SHADOW_UPDATE, actionName, modelVariantId);
  dispatch(uploadConfigToS3AndUpdateShadow(modelCategoryId, modelId, modelVariantId, url, log, widgetCode));
};

export const uploadConfigToS3AndUpdateShadow = (modelCategoryId, modelId, modelVariantId, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    onLoad: status => setModelVariantUnitsLoadingStatus(status),
    onSuccess: retData => setModelVariantShadowUpdatetatusThunk(retData),
    onFailure: err => setModelVariantUnitsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      modelId: modelId,
      modelCategoryId: modelCategoryId,
      modelVariantId: modelVariantId,
      updatedBy: Cookies.get(`userid-${envName}`),
      log: log
    },
    widgetcode: widgetCode
  });

export const setModelVariantShadowUpdatetatusThunk = retData => dispatch => {
  let messageCode = retData && retData.message;

  dispatch(setModelVariantShadowUpdatetatus(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setModelVariantShadowUpdatetatus('', false));
  }, 2500);
};

export const setModelVariantShadowUpdatetatus = (messageCode, status) => ({
  type: UPDATE_MODEL_VARIANT_UNITS_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessfull: true,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});
